<template>
    <div class="sr-no-access">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="content">
            <div>Your account does not have access to this screen.</div>
            <div class="logout-btn" @click="onLogoutClick">Logout</div>
        </div>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';

export default {
    mixins: [mixin, errorMixin],
    components: {
        customModalDialog,
    },
    data() {
        return {
            customModalSettings: {},
            question_uid: this.$route.params.questionId,
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    async mounted() {
        if(!this.accessToken) {
            this.navigateToServiceRequestAuth()
        }
    },
    methods: {
        ...mapMutations({
            removeKeys: 'auth/removeKeys',
        }),
        ...mapActions({}),
        navigateToServiceRequest() {
            console.log(`navigateToServiceRequest`)
            console.log(`questionId:`, this.$route.params.questionId)
            console.log(`type:`, this.$route.params.type)
            this.$router.push({name: 'ServiceRequest', params: {questionId: this.$route.params.questionId, type: this.$route.params.type}})
        },
        navigateToServiceRequestAuth() {
            this.removeKeys()
            this.$router.push({name: 'ServiceRequestAuth', params: {questionId: this.$route.params.questionId, type: this.$route.params.type}})
        },
        onLogoutClick() {
            this.removeKeys()
            this.navigateToServiceRequestAuth()
        },
    }

}
</script>

<style>

</style>
<style scoped>
.sr-no-access {

}
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    row-gap: 25px;
    margin-left: 24px;
    margin-right: 24px;
    text-align: center;
}
.logout-btn {
    background: #999999;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    min-width: 300px;
    max-width: 400px;
}
.logout-btn:hover {
    background: #636363;
}

</style>
